// src/lib/benchmarkView.ts
// Reading GET /api/v2/ui/benchmark. The API narrows the ranking to the hotels
// the user may view and says so in `scope`: `own` for a user who sees one
// hotel of the chain (their row plus the median), `chain` otherwise. An API
// that predates the field sends the full ranking, which is `chain`.
import type { BenchmarkRankingRow, BenchmarkResponse, MetricResultDto } from '@/types/analyticsV2';

export const parseBenchmarkResponse = (
  json: { data?: MetricResultDto[]; scope?: unknown; visibleHotels?: unknown } | MetricResultDto[]
): BenchmarkResponse => {
  if (Array.isArray(json)) return { metrics: json, scope: 'chain', visibleHotels: null };
  return {
    metrics: json.data ?? [],
    scope: json.scope === 'own' ? 'own' : 'chain',
    visibleHotels: typeof json.visibleHotels === 'number' ? json.visibleHotels : null,
  };
};


/** Rank numbers for the ranked rows only (they come first, best first); an unranked row has none. */
export const rankNumbers = (rows: BenchmarkRankingRow[]): (number | null)[] => {
  let rank = 0;
  return rows.map((row) => (row.containment === null ? null : ++rank));
};
